import { useEffect, useState } from "react";
import { useSubscriptionStatus } from "../useSubscriptionStatus";
import SubscriptionGuard from "../SubscriptionGuard";
import RetailPOSCore from "./RetailPOSCore";
import RetailPOSLandingPage from "./RetailPOSLandingPage";
import { useAuthStore } from "../../store/authStore";

export default function RetailPOSApp() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const myStores = useAuthStore((s) => s.myStores);
  const fetchMyStores = useAuthStore((s) => s.fetchMyStores);
  const { status, daysLeft, expiresAtLabel } = useSubscriptionStatus("retail_pos_v1");

  const [loadingStores, setLoadingStores] = useState(false);
  const [storesLoaded, setStoresLoaded] = useState(false);
  const [enterAsMember, setEnterAsMember] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) return;
    setLoadingStores(true);
    fetchMyStores().finally(() => {
      setLoadingStores(false);
      setStoresLoaded(true);
    });
  }, [isAuthenticated, fetchMyStores]);

  if (isAuthenticated && (!storesLoaded || loadingStores)) {
    return <RetailPOSLandingPage showLoading />;
  }

  const stores = Array.isArray(myStores) ? myStores : [];
  const hasOwnStore = stores.some((s) => s.role === "ADMIN");
  const hasMemberStores = !hasOwnStore && stores.length > 0;
  const isStoreMember = hasMemberStores && enterAsMember;

  // Vendedores/encargados no tienen suscripción propia: el dueño paga la tienda.
  const guardStatus = isStoreMember ? "ACTIVE" : status;

  return (
    <SubscriptionGuard
      status={guardStatus}
      daysLeft={daysLeft}
      expiresAtLabel={expiresAtLabel}
      landing={
        <RetailPOSLandingPage
          showMyStoresButton={hasMemberStores}
          onEnterStores={() => setEnterAsMember(true)}
        />
      }
      appKey="retail_pos_v1"
      appName="POS Retail Ropa"
    >
      <RetailPOSCore />
    </SubscriptionGuard>
  );
}
